import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`What are Clips?`}</h2>
    <h3>{`GIFs with Sound.`}</h3>
    <p>{`GIPHY Clips are GIFs with Sound. They combine the expression and entertainment of GIFs, with the added creative layer of audio. Millions of people use GIPHY to communicate and express themselves - GIPHY Clips brings new levels to that expression`}</p>
    <h3>{`Why Sound? Why Now?`}</h3>
    <p>{`People are already using short form video content to react, express and communicate. Fans are finding and sharing their favorite quotes, moments and characters.`}</p>
    <p>{`With GIPHY Clips, we can scale this new form of expression to every conversation. We give users Clips directly from official partners, already cut to the most shareable moments, all organized and curated into a searchable library.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      